/* src/app/shared/campaigns/campaigns.component.scss */
mat-form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.campaigns-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-right: 4px;
}
.campaigns-container:last-child {
  margin-bottom: 16px;
}
.card-container {
  display: block;
  width: 100%;
  background-color: #FFDCC4;
  border-radius: 16px;
}
.campaign-card {
  align-items: center;
  gap: 12px;
}
.campaign-card .campaign-data-box .campaign-name {
  font-weight: 500;
  font-size: medium;
  margin-bottom: 5px;
}
.campaign-card .campaign-data-box .campaign-date-and-step {
  margin: 0;
}
.campaign-card .campaign-data-box .campaign-date-and-step .red-warning-text {
  color: red;
  font-weight: bold;
}
.campaign-card .campaign-status-box {
  margin-left: auto;
}
.campaign-card .campaign-status-box .status-select-box ::ng-deep .mat-mdc-text-field-wrapper {
  padding: 0 10px;
  background-color: #FFBB8E;
  border: 2px solid #F89959;
  border-radius: 10px;
}
.campaign-card .campaign-status-box .status-select-box ::ng-deep .mat-mdc-form-field-infix {
  padding: 8px 0;
  width: 160px;
  max-width: 180px;
  min-height: unset;
}
.campaign-card .campaign-status-box .status-select-box ::ng-deep .mat-mdc-form-field-infix .mat-mdc-select-value-text {
  font-weight: 500;
}
.select-option {
  padding: 8px 16px;
}
.campaign-flip-animation {
  animation: flip-in 600ms ease-in forwards;
}
@keyframes flip-in {
  from {
    transform: rotateX(0deg);
  }
  to {
    transform: rotateX(360deg);
  }
}
.campaign-remove-animation {
  transform: translateX(100%);
  transition: transform 600ms ease-in;
}
:host ::ng-deep .mdc-line-ripple {
  display: none;
}
:host ::ng-deep .mat-mdc-select {
  padding: 0;
  border: unset;
}
/*# sourceMappingURL=campaigns.component.css.map */
